import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

// Bootstrap modules
import { DropdownModule } from 'ng2-bootstrap/dropdown';
import { ModalModule } from 'ng2-bootstrap/modal';
import { PaginationModule } from 'ng2-bootstrap/pagination';

// Guards
import { AuthGuard } from './_guards/auth.guard';

// Services
import { AuthenticationService } from './_services/authentication.service';
import { OrganizationService } from './_services/organization.service';
import { RoleService } from './_services/role.service';
import { UserService } from './_services/user.service';
import { GrantService } from './_services/grant.service';
import { StatusService } from './_services/status.service';
import { ApplicantService } from './_services/applicant.service';

// Pipes
import { FormatDate } from './_pipes/formatDate';
import { RequestType } from './_pipes/requestType';


// Components
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { GrantFormComponent } from './grant-form/grant-form.component';
import { CoverComponent } from './grant-form/cover/cover.component';
import { DemographicComponent } from './grant-form/demographic/demographic.component';
import { InsuranceResidenceComponent } from './grant-form/insuranceresidence/insuranceresidence.component';
import { HouseholdMemberComponent } from './grant-form/household-member/household-member.component';
import { LoginComponent } from './login/login.component';
import { PasswordResetComponent } from './passwordreset/passwordreset.component';
import { SimpleTableComponent } from './shared/simple-table.component';
import { GrantsListComponent } from './grants-list/grants-list.component';
import { UsersComponent } from './users/users.component';
import { UserFormComponent } from './users/user.form.component';
import { CreateUserComponent } from './users/create.user.component';
import { EditUserComponent } from './users/edit.user.component';
import { NarrativeComponent } from "./grant-form/narrative/narrative.component";
import { VendorInfoComponent } from "./grant-form/vendorinfo/vendorinfo.component";
import { VendorPaymentComponent } from "./grant-form/vendorpayment/vendorpayment.component";
import { LoadingComponent } from './shared/loading.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { OrgsComponent }        from './orgs/orgs.component';
import { CreateOrgComponent }   from './orgs/create.org.component';
import { EditOrgComponent }     from './orgs/edit.org.component';
import { OrgFormComponent } from './orgs/org.form.component';

// Providers
import { pafRequestOptionsProvider } from "./_providers/PafRequestOptions.provider"

@NgModule({
  imports: [
    AppRoutingModule,
    BrowserModule,
    FormsModule,
    HttpModule,
    DropdownModule.forRoot(),
    ModalModule.forRoot(),
    PaginationModule.forRoot()
  ],
  declarations: [
    AppComponent,
    SimpleTableComponent,
    GrantsListComponent,
    LoginComponent,
    PasswordResetComponent,
    GrantFormComponent,
    CoverComponent,
    DemographicComponent,
    UsersComponent,
    CreateUserComponent,
    UserFormComponent,
    EditUserComponent,
    InsuranceResidenceComponent,
    HouseholdMemberComponent,
    NarrativeComponent,
    VendorInfoComponent,
    VendorPaymentComponent,
    LoadingComponent,
    FormatDate,
    RequestType,
    MyAccountComponent,
    OrgsComponent,
    CreateOrgComponent,
    EditOrgComponent,
    OrgFormComponent
  ],
  providers: [
    AuthGuard,
    AuthenticationService,
    OrganizationService,
    RoleService,
    UserService,
    GrantService,
    StatusService,
    ApplicantService,
    pafRequestOptionsProvider
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts